





































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Credentials } from '@/modules/users/interfaces/credentials';

const userStore = namespace('UserStore');

@Component({ name: 'RegisterModal' })
export default class RegisterModal extends Vue {
  @userStore.Action
  updateRegisterModalVisibility!: (showLoginModal: boolean) => void;
  @userStore.Action
  register!: (registerRequest: Credentials) => void;
  @userStore.State
  private showRegisterModal?: boolean;
  private showPassword = false;
  private registerRequest = {
    email: '',
    password: '',
  };

  clear(): void {
    this.registerRequest = {
      email: '',
      password: '',
    };
  }
}
